import type { WorldView } from "../render/world-view.js";
import { AnchoredOverlay } from "./anchored-overlay.js";

const MAX_CHARS = 60;

interface BubbleData {
  text: string;
}

export class BubbleManager {
  private readonly overlay: AnchoredOverlay<BubbleData>;

  constructor(layer: HTMLElement, worldView: WorldView) {
    this.overlay = new AnchoredOverlay({
      layer,
      worldView,
      // Longer than the floaters — players need time to read.
      durationMs: 4000,
      fadeBeforeMs: 500,
      // No rise; the .speech-bubble CSS handles positioning above the
      // head via transform. We only anchor at the entity's screen origin.
      yOffset: 0,
      riseProgressPx: 0,
      createNode: ({ text }) => {
        const trimmed = text.length > MAX_CHARS ? text.slice(0, MAX_CHARS - 1) + "…" : text;
        const el = document.createElement("div");
        el.className = "speech-bubble";
        el.textContent = trimmed;
        return el;
      },
    });
  }

  spawn(speakerId: string, text: string, now = performance.now()): void {
    this.overlay.spawn(speakerId, { text }, now);
  }

  destroy(): void {
    this.overlay.destroy();
  }
}
